import gql from 'graphql-tag';

export const ORDER_FOR_EDIT = gql`
  query orderForEdit($id: ID) {
    order(id: $id) {
      id
      isVisited
      isEditable
      groupOrderLast4
      hasErrors
      successorOrder {
        id
      }
      fee
      group {
        id
        name
      }
      platformFee
      canceled
      event {
        id
        closeDate
        endDate
        openDate
        name
        rvProducts {
          id
          endDate
          name
          description
          price
          nightly
          minNights
          rvLot {
            id
            description
            name
            power
            sewer
            water
          }
          startDate
        }
        stallProducts {
          id
          endDate
          name
          description
          nightly
          price
          startDate
          minNights
        }
        startDate
        venue {
          id
          stripeAccountType
          interactiveMaps
          interactiveMapsForRenters
          requiredMapAssignmentsForRenters
          allowCardReaderPayments
          stripeLocation
          extraChargesEnabled
          requiredQuestionsForAdmins
          buildings {
            id
            name
          }
          rvLots {
            id
            name
          }
          maps {
            id
            name
            type
            url
            buildings
          }
          venueConfig {
            requiredAddons
          }
        }
        addOnProducts {
          id
          price
          disabled
          booked
          addOn {
            id
            name
            description
            unitName
          }
        }
        requiredAddOns {
          id
          eventId
          addOnProduct
          xRefTypeId
          ratio
          condition
          max
        }
      }
      notes
      adminNotes
      addOnDeliveryNotes
      orderItems {
        id
        addOnProduct {
          id
          price
          addOn {
            id
            name
            unitName
          }
        }
        reservation {
          id
          endDate
          rvProduct {
            id
            name
            description
            price
            nightly
            minNights
            rvLot {
              id
              description
              name
              power
              sewer
              water
            }
          }
          rvSpots {
            id
            name
          }
          stallProduct {
            id
            name
            description
            nightly
            price
            minNights
          }
          stalls {
            id
            building {
              id
              name
            }
            name
            description
            status
          }
          startDate
          status {
            id
            name
          }
        }
        quantity
      }
      payments {
        id
        admin {
          id
        }
        amount
        cardBrand
        cardPayment
        createdAt
        last4
        notes
        serviceFee
        stripeFee
        ssChargeId
        ssRefundId
        success
        cardReader
        adminCharge
        discountCodeValue
        discountCodeId
        subtotalBeforeDiscount
        globalDiscountAmount
      }
      groupPayments {
        amount
        isRefund
      }
      total
      user {
        id
        email
        firstName
        fullName
        lastName
        phone
      }
      stallQuestionAnswers {
        id
        questionId
        question
        answerOptions
        answer
        questionType
        required
        minLength
        maxLength
      }
      rvQuestionAnswers {
        id
        questionId
        question
        answerOptions
        answer
        questionType
        required
        minLength
        maxLength
      }
    }
  }
`;
